import React, { useEffect, useState, useCallback } from 'react';
import { useApi } from '../../hooks/useApi';
import { useClub } from '../../hooks/useClub';
import { SwitchTask } from '../dashboard/ClubDashboardModule';
import { useAuth } from '../../hooks/useAuth';

// Nationwide Upsell (BK, 10/7/26). Members on a club-LOCAL plan (only good at the club they bought it at) who
// have played at a different club even a few times in the last 30 days. They are already using other clubs, so Nationwide is a
// natural offer. Lives in Lead Engine next to Punch Pass Upsell (Josh's module). Fed nightly from
// membership_club_flags; contacts log to the shared timeline (module membership_switch).
export default function LeadNationwideUpsell() {
  const { get } = useApi();
  const { currentClub } = useClub();
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [scope, setScope] = useState('all'); // 'all' clubs (default, Josh works every club) or the club selected at the top

  const load = useCallback(() => {
    setError(null);
    get(scope === 'club' ? `/lead/nationwide-upsell?club=${currentClub.id}` : '/lead/nationwide-upsell')
      .then(setData)
      .catch(e => setError(e.message || 'Failed to load'));
  }, [currentClub.id, scope]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { load(); }, [load]);

  if (error) return <div className="empty-state"><div className="empty-state-text">{error}</div></div>;
  if (!data) return <div className="empty-state"><div className="spinner" /></div>;
  const toggle = (
    <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
      {[['all', 'All clubs'], ['club', currentClub.name || currentClub.id]].map(([k, label]) => (
        <button key={k} className={scope === k ? 'btn' : 'btn btn-secondary'} style={{ fontSize: 12, padding: '4px 12px' }}
          onClick={() => { setData(null); setScope(k); }}>{label}</button>
      ))}
    </div>
  );
  if (!data.tasks.length) {
    return <div>{toggle}<div className="empty-state"><div className="empty-state-text">
      {scope === 'all' ? 'No local-plan members are playing at another club right now.' : `No local-plan members are playing at ${currentClub.name || currentClub.id} right now.`}
    </div></div></div>;
  }
  const byClub = {};
  for (const t of data.tasks) (byClub[t.playClub] = byClub[t.playClub] || []).push(t);
  const CLUB_NAMES = { DEN: 'Denton', LEW: 'Lewisville', MCK: 'McKinney', GB: 'Green Bay', MF: 'Menomonee Falls', WA: 'West Allis' };
  return (
    <div>
    {toggle}
    <div className="card" style={{ padding: '6px 20px 12px' }}>
      <div style={{ fontSize: 12, color: 'var(--text-muted)', padding: '10px 0 2px' }}>
        Local-plan members who have played here (2+ visits in the last 30 days). Their plan is only good at the club
        they bought it at, so Nationwide is the natural offer.
      </div>
      {Object.entries(byClub).map(([club, tasks]) => (
        <div key={club}>
          <div className="section-header" style={{ marginTop: 14 }}>Playing at {CLUB_NAMES[club] || club} · {tasks.length}</div>
          {tasks.map(t => <SwitchTask key={t.email} t={t} clubId={club} repName={user?.name} onLogged={load} />)}
        </div>
      ))}
    </div>
    </div>
  );
}
